import { trpc } from "../../../lib/api/trpc";

export type VersionHistoryEntry = {
  id: string;
  filename: string;
  versionNumber: number;
  status: string;
  createdAt: string;
  sizeBytes: number;
  chunkCount: number;
  isCurrent: boolean;
};

export const useVersionHistory = (documentId: string) => {
  // @ts-ignore - tRPC type inference through `as any` router cast
  const { data, isLoading, isError, error, refetch } =
    trpc.documents.getVersionHistory.useQuery(
      { documentId },
      { enabled: !!documentId },
    );

  return {
    versions: (data as VersionHistoryEntry[]) || [],
    isLoading,
    isError,
    error,
    refetch,
  };
};
